import { useTranslation } from "react-i18next";
import { useStorageSelectors } from "../../app/state/storageObjectSlice/hook/use-storage-selectors";
import { ResizableWrapper } from "../../shared/components/ResizableWrapper";
import { MeetingChat } from "./Components/MeetingChat";
import { Transcript } from "./Components/Transcript";
import { NoObjectChosen } from "../../common/NoObjectChosen";
import { useAppDispatch } from "../../services/redux/hooks/use-dispatch";
import { addStorageObject } from "../../app/state/storageObjectSlice/actions/actions";
import { MeetingHeader } from "./Components/Transcript/Components/MeetingHeader";
import styles from "./styles.module.css";

interface Props {
  className?: string;
}

export const Meeting = ({ className }: Props) => {
  const dispatch = useAppDispatch();
  const { selectedObject } = useStorageSelectors("meetings");
  const { t } = useTranslation();

  const name = t("meetings.default_name");

  if (selectedObject?.value === null) {
    return (
      <NoObjectChosen
        message={"Выберите или создайте объект Встречи в "}
        folderName={selectedObject?.friendly_name}
        onClick={() =>
          dispatch(
            addStorageObject({ name, service: "meetings", objectType: "child" })
          )
        }
      />
    );
  }

  return (
    <ResizableWrapper
      leftBlock={<Transcript />}
      rightBlock={<MeetingChat />}
      leftBlockSize={60}
      rightBlockSize={40}
      leftClassName={styles["left-block"]}
      rightClassName={styles["right-block"]}
    />
  );
};
